module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ed.1bc982b1.png";